import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RolePermission, RolePermissionCreate, RolePermissionFilter } from '../data/rolePermission';

export function createRolePermissionService(client: AxiosInstance) {
  return createCrudService<RolePermission, RolePermissionCreate, RolePermissionFilter>(
    client,
    '/authorization/RolePermission',
    'id',
  );
}

export type RolePermissionService = CrudService<RolePermission, RolePermissionCreate, RolePermissionFilter>;
